module.exports = __webpack_public_path__ + "img/hero_old.161d24fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero_old.jpg
// module id = Xl4M
// module chunks = 0